import { Region } from '@hiwaldo/sdk/enums';

export const storeRegion = (): Region => {
  return Region.US;
};
